
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/empowering-sustainable-growth",
      function () {
        return require("private-next-pages/empowering-sustainable-growth/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/empowering-sustainable-growth"])
      });
    }
  